import { ToastIcon } from '../services/toast.type';

export const closeToastIcon: ToastIcon = {
  svgData: `<svg width="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m8.405 13.595 5.188-5.189m0 5.189L8.405 8.406m5.345 11.76c4.583 0 6.416-1.833 6.416-6.416v-5.5c0-4.584-1.833-6.417-6.417-6.417h-5.5c-4.583 0-6.416 1.833-6.416 6.417v5.5c0 4.583 1.833 6.416 6.416 6.416h5.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
};
